import { faCircleStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        badge: {
            color: '#EAB464',
            fontSize: '16px'
        }
    })
);

export const MemberBadge = () => {
    const classes = useStyles();
    return (
        <FontAwesomeIcon
            icon={faCircleStar}
            className={classes.badge}
            title="Has an active membership"
        />
    );
};
